import React, { useState, useEffect } from "react";
import axios from "axios";
import CircularProgress from "@material-ui/core/CircularProgress";

// THis is for the /// Check status button...

const hexcodeApiUrl = `https://dev.iondeveloper.com/api/proposal/hexcode/?api_key=${process.env.REACT_APP_API_KEY}`;

const CallPilot = ({
  envelopeId,
  envelopeStatus,
  setEnvelopeStatus,
  projectID,
  ppa,
  financeSource,
  variant = "all", // "all" | "checkStatusOnly" | "welcomeCallOnly"
  loanTerm,
  loanApr,
  firstMonthPayment,
  customerPhone,
}) => {
  const [loading, setLoading] = useState(false);
  const [ciaShareLink, setCiaShareLink] = useState("");
  const [copied, setCopied] = useState(false);
  const [hexcodeLoading, setHexcodeLoading] = useState(false);
  const [hexcodeErrorMessage, setHexcodeErrorMessage] = useState(null);
  const [hexcodeSuccessMessage, setHexcodeSuccessMessage] = useState(null);

  const copyWelcomeCallLink = () => {
    navigator.clipboard.writeText(callPilotUrl).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const handlePhoneWelcomeCall = async (who) => {
    setHexcodeErrorMessage(null);
    setHexcodeSuccessMessage(null);
    setHexcodeLoading(true);
    try {
      const phoneDigits = (customerPhone || "").replace(/\D/g, "");
      const body = {
        method: "start_hexcode_call",
        sf_project_id: projectID,
        loan_term: loanTerm,
        loan_apr: loanApr,
        first_month_payment: firstMonthPayment,
        phone_number: phoneDigits || false,
      };
      if (who) body.who = who;
      const response = await axios.post(hexcodeApiUrl, body);
      const data = response?.data;
      if (data && data.success === true) {
        setHexcodeSuccessMessage(data.message || "Phone welcome call started.");
      } else if (data && data.success === false) {
        setHexcodeErrorMessage(data.message || "The request was unsuccessful.");
      }
    } catch (err) {
      setHexcodeErrorMessage(err?.response?.data?.message || err?.message || "Failed to start phone welcome call.");
    } finally {
      setHexcodeLoading(false);
    }
  };

  const apiUrl = `https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`;
  const salesApiUrl = `https://dev.iondeveloper.com/api/rep/docusign/?api_key=${process.env.REACT_APP_API_KEY}`;
  const callPilotUrl = `https://ionsolar.callpilot.io/public/launcher?token=10fd6b7e-a2ad-53b5-319d-148600794635&session=${projectID}&surveyType=105&code=WutaBy5anqkXBw`;

  const getEnvelopeData = async () => {
    try {
      const response = await axios.post(salesApiUrl, {
        method: "get_envelope_data",
        envelope_id: envelopeId,
        project_id: projectID,
      });
      // console.log(response.data)
      setEnvelopeStatus(response.data.status);
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  const getEnvelopeDetails = async () => {
    try {
      const response = await axios.post(salesApiUrl, {
        method: "get_envelope_details",
        envelope_id: envelopeId,
      });
      console.log(response.data);

      const recipients = response.data.recipients;
      for (const recipient of recipients) {
        if (recipient.recipient_type === "signer") {
          console.log(recipient.shared_link);
          return setCiaShareLink(recipient.shared_link);
        }
      }
      // setLoading(false)
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (envelopeId && envelopeStatus === "") {
      getEnvelopeData();
    }
  }, []);
  // useEffect(() => {
  //   if (envelopeId) {
  //     getEnvelopeDetails()
  //   }
  // }, [])

  const showCheckStatus =
    envelopeStatus === "sent" ||
    envelopeStatus === "document.sent" ||
    envelopeStatus === "document.viewed";
  const showWelcomeCall =
    envelopeStatus === "completed" || envelopeStatus === "document.completed";
  const showDeclined =
    envelopeStatus === "declined" || envelopeStatus === "document.declined";
  const hideAll = envelopeStatus === "" && envelopeId === false && +ppa !== 1;

  const welcomeCallPhoneColumn = (
    <div className="col-sm-4 col-6">
      <button
        type="button"
        className="proposalButton cancel"
        style={{ marginTop: "10px", marginBottom: "0px" }}
        disabled={hexcodeLoading}
        onClick={() => handlePhoneWelcomeCall()}
      >
        {hexcodeLoading ? <CircularProgress size={24} color="inherit" /> : "AI Welcome Call"}
      </button>
      {/* <input
        type="tel"
        className="form-control"
        style={{ marginTop: "8px", width: "100%" }}
        placeholder="Phone number (optional)"
        autoComplete="tel"
        aria-label="Phone number for welcome call"
      /> */}
    </div>
  );

  if (hideAll) return null;

  if (variant === "checkStatusOnly") {
    if (showCheckStatus) {
      return (
        <button
          className="proposalButton cancel"
          style={{ marginTop: "10px", marginBottom: "0px" }}
          onClick={() => {
            setLoading(true);
            getEnvelopeData();
          }}
        >
          {loading ? (
            <CircularProgress size={40} color="inherit" />
          ) : (
            "CIA Pending - Check Status"
          )}
        </button>
      );
    }
    if (showDeclined) {
      return <div className="errorMessage">Customer Declined Signature of CIA</div>;
    }
    return null;
  }

  if (variant === "welcomeCallOnly") {
    if (!showWelcomeCall) return null;
    return (
      <>
        <div className="row">
          <div className="col-sm-4 col-6">
            <a href={callPilotUrl} target="_blank" rel="noopener noreferrer">
              <button className="proposalButton cancel" style={{ marginTop: "10px", marginBottom: "0px" }}>
                Call Pilot Welcome Call
              </button>
            </a>
          </div>
          <div className="col-sm-4 col-6">
            <button
              type="button"
              className="proposalButton cancel"
              style={{ marginTop: "10px", marginBottom: "0px" }}
              onClick={copyWelcomeCallLink}
            >
              {copied ? "Copied!" : "Copy Call Pilot Link"}
            </button>
          </div>
          {welcomeCallPhoneColumn}
        </div>
        {/* <div className="row mt-2">
          <div className="col-sm-4 col-6">
            <button
              type="button"
              className="proposalButton cancel"
              style={{ marginTop: "10px", marginBottom: "0px" }}
              disabled={hexcodeLoading}
              onClick={() => handlePhoneWelcomeCall("Mark")}
            >
              Mark
            </button>
          </div>
          <div className="col-sm-4 col-6">
            <button
              type="button"
              className="proposalButton cancel"
              style={{ marginTop: "10px", marginBottom: "0px" }}
              disabled={hexcodeLoading}
              onClick={() => handlePhoneWelcomeCall("Braxton")}
            >
              Braxton
            </button>
          </div>
          <div className="col-sm-4 col-6">
            <button
              type="button"
              className="proposalButton cancel"
              style={{ marginTop: "10px", marginBottom: "0px" }}
              disabled={hexcodeLoading}
              onClick={() => handlePhoneWelcomeCall("Riley")}
            >
              Riley
            </button>
          </div>
        </div> */}
        {hexcodeErrorMessage && (
          <div className="text-danger small mt-2" role="alert">
            {hexcodeErrorMessage}
          </div>
        )}
        {hexcodeSuccessMessage && (
          <div className="text-success small mt-2" role="status">
            {hexcodeSuccessMessage}
          </div>
        )}
      </>
    );
  }

  // variant === "all" (default)
  return (
    <>
      {showCheckStatus ? (
        <button
          className="proposalButton cancel"
          style={{ marginTop: "10px", marginBottom: "0px" }}
          onClick={() => {
            setLoading(true);
            getEnvelopeData();
          }}
        >
          {loading ? (
            <CircularProgress size={40} color="inherit" />
          ) : (
            "CIA Pending - Check Status"
          )}
        </button>
      ) : showWelcomeCall ? (
        <>
          <div className="row">
            <div className="col-sm-4 col-6">
              <a href={callPilotUrl} target="_blank" rel="noopener noreferrer">
                <button className="proposalButton cancel" style={{ marginTop: "10px", marginBottom: "0px" }}>
                  Call Pilot Welcome Call
                </button>
              </a>
            </div>
            <div className="col-sm-4 col-6">
              <button
                type="button"
                className="proposalButton cancel"
                style={{ marginTop: "10px", marginBottom: "0px" }}
                onClick={copyWelcomeCallLink}
              >
                {copied ? "Copied!" : "Copy Call Pilot Link"}
              </button>
            </div>
            {welcomeCallPhoneColumn}
          </div>
          {/* <div className="row mt-2">
            <div className="col-sm-4 col-6">
              <button
                type="button"
                className="proposalButton cancel"
                style={{ marginTop: "10px", marginBottom: "0px" }}
                disabled={hexcodeLoading}
                onClick={() => handlePhoneWelcomeCall("Mark")}
              >
                Mark
              </button>
            </div>
            <div className="col-sm-4 col-6">
              <button
                type="button"
                className="proposalButton cancel"
                style={{ marginTop: "10px", marginBottom: "0px" }}
                disabled={hexcodeLoading}
                onClick={() => handlePhoneWelcomeCall("Braxton")}
              >
                Braxton
              </button>
            </div>
            <div className="col-sm-4 col-6">
              <button
                type="button"
                className="proposalButton cancel"
                style={{ marginTop: "10px", marginBottom: "0px" }}
                disabled={hexcodeLoading}
                onClick={() => handlePhoneWelcomeCall("Riley")}
              >
                Riley
              </button>
            </div>
          </div> */}
          {hexcodeErrorMessage && (
            <div className="text-danger small mt-2" role="alert">
              {hexcodeErrorMessage}
            </div>
          )}
          {hexcodeSuccessMessage && (
            <div className="text-success small mt-2" role="status">
              {hexcodeSuccessMessage}
            </div>
          )}
        </>
      ) : showDeclined ? (
        <div className="errorMessage">Customer Declined Signature of CIA</div>
      ) : null}
    </>
  );
};

export default CallPilot;
